export class CustomerLedgerGlEntry {
    public id:number|null;
    public customer_ledger_entry_id:number|null;
    public entry_no:number|null;
    public gl_account_no:string;
    public amount:number|null;
    public debit_amount:number|null;
    public credit_amount:number|null;
    public business_line:string;
    public project:string;

    constructor(data:CustomerLedgerGlEntryData|void) {
        if(data === undefined)
        {
            this.id = null;
            this.customer_ledger_entry_id = null;
            this.entry_no = null;
            this.gl_account_no = "";
            this.amount = null;
            this.debit_amount = null;
            this.credit_amount = null;
            this.business_line = "";
            this.project = "";

        }
        else
        {
            this.id = data.id;
            this.customer_ledger_entry_id =data.customer_ledger_entry_id
            this.entry_no =data.entry_no
            this.gl_account_no =data.gl_account_no;
            this.amount =data.amount;
            this.debit_amount =data.debit_amount;
            this.credit_amount =data.credit_amount;
            this.business_line =data.business_line;
            this.project =data.project;
        }
    }
}

export type CustomerLedgerGlEntryData = {
    id:number|null;
    customer_ledger_entry_id:number|null;
    entry_no:number|null;
    gl_account_no:string;
    amount:number|null;
    debit_amount:number|null;
    credit_amount:number|null;
    business_line:string;
    project:string;
}